"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCard = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var luxon_1 = require("luxon");
var DateManagement_1 = require("../../utils/DateManagement");
var Card_1 = require("@amzn/atoz-web/Card");
var Row_1 = require("@amzn/atoz-web/Row");
var Text_1 = require("@amzn/atoz-web/Text");
var View_1 = require("@amzn/atoz-web/View");
var Icons_1 = require("@amzn/atoz-web/Icons");
var Modal_1 = require("@amzn/atoz-web/Modal");
var PunchCardLink_1 = require("../PunchCardLink");
var Theme_1 = require("@amzn/atoz-web/Theme");
var PunchCard = function (_a) {
    var _b, _c;
    var timeIn = _a.timeIn, timeOut = _a.timeOut, militaryTime = _a.militaryTime, timeInDeletable = _a.timeInDeletable, timeOutDeletable = _a.timeOutDeletable, renderPunchDeletionConfirmationModal = _a.renderPunchDeletionConfirmationModal;
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeInDT = (_b = timeIn !== null && timeIn !== void 0 ? timeIn : timeOut) !== null && _b !== void 0 ? _b : luxon_1.DateTime.local();
    var timeOutDT = (_c = timeOut !== null && timeOut !== void 0 ? timeOut : timeIn) !== null && _c !== void 0 ? _c : luxon_1.DateTime.local();
    var inTimeOnly = timeIn ? (0, DateManagement_1.getTimeString)(timeInDT, militaryTime) : '--';
    var outTimeOnly = timeOut ? (0, DateManagement_1.getTimeString)(timeOutDT, militaryTime) : '--';
    var inMonth = t("time_and_attendance_PunchCard_daySelector_".concat(timeInDT.month));
    var outMonth = t("time_and_attendance_PunchCard_daySelector_".concat(timeOutDT.month));
    var missed = !timeIn || !timeOut;
    var inDay = timeInDT.day;
    var outDay = timeOutDT.day;
    var ariaLabel = t('time_and_attendance_PunchCard_ariaLabel', {
        inTime: inTimeOnly,
        inMonth: inMonth,
        inDay: inDay,
        outTime: outTimeOnly,
        outMonth: outMonth,
        outDay: outDay
    });
    return (react_1.default.createElement(PunchCardContainer, { dataTestId: "PunchCard", justifyContent: "center", tabIndex: 0, "aria-label": ariaLabel },
        react_1.default.createElement(Row_1.Row, { width: "100%" },
            renderPunchDeletionConfirmationModal && (react_1.default.createElement(PunchTime, { punchDateTime: timeInDT, punchTime: inTimeOnly, punchMonth: inMonth, punchDay: inDay, renderPunchDeletionConfirmationModal: renderPunchDeletionConfirmationModal, timeDeletable: timeInDeletable })),
            react_1.default.createElement(PunchCardLink_1.PunchCardLink, { showAlertIcon: missed }),
            renderPunchDeletionConfirmationModal && (react_1.default.createElement(PunchTime, { punchDateTime: timeOutDT, punchTime: outTimeOnly, punchMonth: outMonth, punchDay: outDay, renderPunchDeletionConfirmationModal: renderPunchDeletionConfirmationModal, timeDeletable: timeOutDeletable })))));
};
exports.PunchCard = PunchCard;
var PunchTime = function (_a) {
    var punchDateTime = _a.punchDateTime, punchTime = _a.punchTime, punchMonth = _a.punchMonth, punchDay = _a.punchDay, renderPunchDeletionConfirmationModal = _a.renderPunchDeletionConfirmationModal, timeDeletable = _a.timeDeletable;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(View_1.View, { width: "40%" },
        react_1.default.createElement(Text_1.Text, { fontSize: "T300", fontWeight: "bold", textAlign: "center" },
            punchTime.toLocaleLowerCase(),
            timeDeletable && renderPunchDeletionConfirmationModal && (react_1.default.createElement(DeleteButtonWithModal, { title: t("time_and_attendance_Delete_Ashcan_img_alt"), renderPunchDeletionConfirmationModal: renderPunchDeletionConfirmationModal, punchDateTime: punchDateTime }))),
        react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T100", textAlign: "center" }, "".concat(punchMonth, " ").concat(punchDay))));
};
var DeleteButtonWithModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Modal_1.WithModal, { renderModal: function (_a) {
            var close = _a.close;
            return props.renderPunchDeletionConfirmationModal({ close: close }, props.punchDateTime);
        } }, function (_a) {
        var open = _a.open;
        return (react_1.default.createElement(DeleteButton, { onClick: open },
            react_1.default.createElement(Icons_1.IconBin, { title: props.title, color: "red80", size: Icons_1.IconSize.ExtraSmall, onClick: open, dataTestId: "delete-punch-icon", "aria-label": t('time_and_attendance_PunchCard_DeleteButton_ariaLabel') })));
    }));
};
var PunchCardContainer = (0, Theme_1.styledWithTheme)(Card_1.Card)("\n    margin: 0;\n    padding-top: 16px;\n    padding-bottom: 12px;\n    text-align: center;\n    border: none;\n    position: relative;\n  ");
var DeleteButton = (0, Theme_1.styledWithTheme)('button')("\n      background-color: transparent;\n      border: none;\n      flex: 0 1 15%;\n\n      &:hover {\n          cursor: pointer;\n      }\n  ");
